export const site = {
  name: "51吃瓜",
  tagline: "今日新鲜瓜，一看便知",
  slogan: "51吃瓜每日更新今日新鲜瓜，新瓜推荐、定时开吃、热门事件实时同步。",
  description:
    "51吃瓜是一个聚合全网娱乐热点的资讯门户，围绕明星动态、影视追踪、综艺看点、音乐现场、时尚风向与海外娱乐，每日更新今日新鲜瓜，让你一搜便知今天有什么瓜。",
  email: "hello@51chigua.example.com",
  updatedAt: "2026-09-12",
};

export interface NavItem {
  label: string;
  path: string;
}

export const navItems: NavItem[] = [
  { label: "首页", path: "/" },
  { label: "瓜田分类", path: "/category/star" },
  { label: "今日热瓜榜", path: "/rank" },
  { label: "关于我们", path: "/about" },
];

export const footerLinks: { title: string; items: NavItem[] }[] = [
  {
    title: "逛瓜田",
    items: [
      { label: "首页", path: "/" },
      { label: "今日热瓜榜", path: "/rank" },
      { label: "明星动态", path: "/category/star" },
      { label: "影视追踪", path: "/category/film" },
    ],
  },
  {
    title: "热门栏目",
    items: [
      { label: "综艺看点", path: "/category/variety" },
      { label: "音乐现场", path: "/category/music" },
      { label: "时尚风向", path: "/category/fashion" },
      { label: "海外娱乐", path: "/category/overseas" },
    ],
  },
  {
    title: "关于本站",
    items: [
      { label: "关于我们", path: "/about" },
      { label: "内容原则", path: "/about#principles" },
      { label: "投稿与合作", path: "/about#contact" },
      { label: "常见问题", path: "/about#faq" },
    ],
  },
];